/**
 * Note templates — predefined prompts that prefill the typed-note textarea.
 * Picking one also sets the touch type. Reps edit before saving; AI structures
 * the result the same as a free-form note.
 *
 * Add or edit templates here — they ship with the client bundle, no DB.
 */
export const NOTE_TEMPLATES = [
  {
    id: 'qbr',
    label: 'Quarterly business review',
    touch_type: 'visit',
    prompt: [
      'QBR with [Customer] — [date].',
      'Attendees: ',
      '',
      'Recent activity / volume: ',
      'What\'s working: ',
      'Pain points: ',
      'Competitive activity: ',
      'Next-quarter plan: ',
      'Asks of UT: ',
    ].join('\n'),
  },
  {
    id: 'new-product',
    label: 'New product introduction',
    touch_type: 'visit',
    prompt: [
      'Introduced [product] to [Customer] — [date].',
      'Their current setup: ',
      'Their reaction: ',
      'Objections raised: ',
      'Interest level (1-5): ',
      'Next step: ',
    ].join('\n'),
  },
  {
    id: 'issue',
    label: 'Issue resolution',
    touch_type: 'call',
    prompt: [
      'Issue: ',
      'Customer: ',
      'When it started: ',
      'Impact on customer: ',
      'Action taken: ',
      'Open items: ',
      'Follow-up needed by: ',
    ].join('\n'),
  },
  {
    id: 'cold-call',
    label: 'Cold call / prospecting',
    touch_type: 'call',
    prompt: [
      'Prospect: ',
      'Source / referral: ',
      'Their fleet size / business: ',
      'Current trailer supplier: ',
      'Pain points heard: ',
      'Interest level (1-5): ',
      'Next step: ',
    ].join('\n'),
  },
  {
    id: 'lost-deal',
    label: 'Lost deal post-mortem',
    touch_type: 'note',
    prompt: [
      'Customer: ',
      'What we lost: ',
      'Won by: ',
      'Reason given: ',
      'Real reason (read between the lines): ',
      'What we could have done differently: ',
      'When to re-engage: ',
    ].join('\n'),
  },
  {
    id: 'won-deal',
    label: 'Won deal',
    touch_type: 'note',
    prompt: [
      'Customer: ',
      'What we won: ',
      'Order value: ',
      'Delivery timeline: ',
      'What sealed it: ',
      'Implementation owner on customer side: ',
      'Risks to deliver: ',
    ].join('\n'),
  },
  {
    id: 'check-in',
    label: 'Routine check-in',
    touch_type: 'call',
    prompt: [
      'Check-in with [Customer] — [date].',
      'How\'s business: ',
      'Anything we should know: ',
      'Next touch: ',
    ].join('\n'),
  },
];
